<template>
  <div id="stores-list">
    <div v-for="store in stores" :key="`store-${store.ID}`">
      <store-details
        :store="store"
      ></store-details>
    </div>
  </div>
</template>

<script>
  import StoreDetails from './store-details.vue'

  export default {
    props: [
      'stores',
    ],
    components: {
      'store-details': StoreDetails,
    }
  }
</script>

<style scoped>

#stores-list {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 480px;
}

</style>
